<template>
    <header class="header-area">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">                        
                    <div class="header-inner">
                        <nav class="navbar navbar-expand-lg">
                            <router-link class="navbar-brand" to="/">
                                <img src="/assets/img/logo.png" alt="Logo">
                            </router-link>
                            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <i class="las la-bars"></i>
                            </button>
                            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                                <ul class="navbar-nav mx-auto">
                                    <li class="nav-item">
                                        <router-link to="/" class="nav-link" @click="handleHomeClick">Home</router-link>
                                    </li>
                                    <li class="nav-item">
                                        <router-link to="/#about" class="nav-link">About</router-link>
                                    </li>
                                    <li class="nav-item">
                                        <router-link to="/#services" class="nav-link">Menu</router-link>
                                    </li>
                                    <li class="nav-item">
                                        <router-link to="/#project" class="nav-link">Gallery</router-link>
                                    </li>
                                    <li class="nav-item">
                                        <router-link to="/#blog" class="nav-link">News</router-link>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: 'Navbar',
    methods: {
        handleHomeClick() {
            // ホームページのトップにスクロール
            if (this.$route.path === '/') {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
    },
    mounted() {
        // ルート変更時にハッシュ部分へのスクロール処理
        this.$router.afterEach((to) => {
            if (to.hash) {
                this.$nextTick(() => {
                    const element = document.querySelector(to.hash);
                    if (element) {
                        const offset = 80; // ヘッダーの高さ分のオフセット
                        const targetPosition = element.offsetTop - offset;
                        window.scrollTo({
                            top: targetPosition,
                            behavior: 'smooth'
                        });
                    }
                });
            }
        });
    }
}
</script>

<style scoped>
.header-area {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    background: white;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    padding: 15px 0;
}

.navbar {
    padding: 0;
}

.navbar-brand img {
    max-height: 50px;
}

.navbar-nav {
    align-items: center;
}

.navbar-nav .nav-item {
    margin: 0 10px;
}

.navbar-nav .nav-link {
    color: #333;
    padding: 8px 15px;
    transition: color 0.3s;
    font-weight: 500;
    text-decoration: none;
}

.navbar-nav .nav-link:hover,
.navbar-nav .nav-link.active {
    color: #7c5739;
}

.navbar-toggler {
    border: none;
    outline: none;
    padding: 4px 8px;
}

.navbar-toggler i {
    font-size: 24px;
    color: #333;
}

.navbar-toggler:focus {
    outline: none;
    box-shadow: none;
}

/* レスポンシブ対応 */
@media (max-width: 991px) {
    .navbar-collapse {
        background: white;
        padding: 20px 0;
        margin-top: 15px;
        border-top: 1px solid #eee;
    }
    
    .navbar-nav .nav-item {
        margin: 5px 0;
    }
    
    .navbar-nav .nav-link {
        padding: 10px 20px;
    }
}
</style>
